<template>
  <div>
    <v-app-bar elevation="2" class="sticky-top">
      <v-btn icon v-if="!cantGoBack" @click="back">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>

      <v-toolbar-title>
        Exercices
        <span v-if="this.onlyRefs">de référence</span></v-toolbar-title
      >

      <v-spacer></v-spacer>
    </v-app-bar>

    <div>
      <v-data-table
        :headers="headers"
        :items="exercices"
        item-key="id"
        :options.sync="options"
        :server-items-length="totalExercices"
        :footer-props="{
          'items-per-page-options': pageSizes,
        }"
        :items-per-page="pageSize"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        @click:row="selectExercise"
      >
        <!-- Filters params -->
        <template v-slot:[`body.prepend`]>
          <tr>
            <td>
              <v-text-field
                v-model="searchParams.title"
                type="text"
                label="Titre"
                @input="isTyping = true"
                clearable
                @click:clear="onClearTitleClicked()"
              ></v-text-field>
            </td>
            <td>
              <v-select
                v-model="searchParams.destinationType"
                :items="destinationTypeItems"
                attach
                Destination
                label="Destination"
                @input="isTyping = true"
                clearable
                @click:clear="onClearDestinationClicked()"
              ></v-select>
            </td>
            <td>
              <v-text-field
                v-model="searchParams.discipline"
                type="text"
                label="Discipline"
                @input="isTyping = true"
                clearable
                @click:clear="onClearDisciplineClicked()"
              ></v-text-field>
            </td>
            <td>
              <v-text-field
                v-model="searchParams.user"
                type="text"
                label="Créateur"
                @input="isTyping = true"
                clearable
                @click:clear="onClearUserClicked()"
              ></v-text-field>
            </td>
            <td v-if="!onlyRefs">
              <v-select
                v-model="searchParams.exerciseType"
                :items="exerciseTypeItems"
                Type
                attach
                label="Type"
                @input="isTyping = true"
                clearable
                @click:clear="onClearTypeClicked()"
              ></v-select>
            </td>
            <td></td>
          </tr>
        </template>
        <!-- DDL Destination Type -->
        <template v-slot:[`item.destinationType`]="{ item }">
          {{
            destinationTypeItems.find((e) => e.value === item.destinationType)
              .text
          }}
        </template>
        <!-- DDL Exercise Type -->
        <template v-slot:[`item.exerciseType`]="{ item }">
          {{
            exerciseTypeItems.find((e) => e.value === item.exerciseType).text
          }}
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import { GetExercisesForCurrentUserLightAsync } from "@/api/exerciseApi";
import { bus } from "@/main";
import { ExerciceSortType } from "@/models/enums";
import { ExerciseType } from "@/models/enums";
import { DestinationType } from "@/models/enums";
import store from "@/store";
import AuthService from "@/services/AuthService";

export default {
  name: "exercises-list",

  props: ["close", "canGoBack", "onlyRefs"],

  data() {
    return {
      // Search part ===
      searchParams: {
        id: null,
        title: "",
        destinationType: null,
        user: "",
        exerciseType: "",
        discipline: "",
      },
      destinationTypeItems: [
        { text: "Transversal", value: DestinationType.PUBLIC },
        { text: "Spécifique", value: DestinationType.DISCIPLINE },
        { text: "Fédéral", value: DestinationType.FEDERAL },
        { text: "Entraîneur", value: DestinationType.COACH },
      ],
      exerciseTypeItems: [
        { text: "Exercice", value: ExerciseType.EXERCISE },
        { text: "Test (évaluation)", value: ExerciseType.EVALUATION },
        { text: "Situation de référence", value: ExerciseType.REFERENCE },
      ],
      isTyping: false,
      // Pagination part =======
      totalExercices: 0,
      options: {},
      page: 1,
      pageSize: 5,
      pageSizes: [5, 10, 20],
      userId: null,
      exercices: [],
      // Sort part ======
      sortBy: "id",
      sortDesc: true,
      // Others part ==
      exercises: [],
      cantGoBack: !!this.canGoBack,
      id: null,
      title: null,
      destination: null,
      user: null,
      type: null,
      discipline: null,
    };
  },

  watch: {
    options: {
      handler() {
        // Refresh the exercice page with the provided parameters
        this.getExercicePage();
      },
      deep: true,
    },
    "searchParams.title": _.debounce(function () {
      this.isTyping = false;
    }, 1000),
    "searchParams.destinationType": _.debounce(function () {
      this.isTyping = false;
    }, 100),
    "searchParams.user": _.debounce(function () {
      this.isTyping = false;
    }, 1000),
    "searchParams.exerciseType": _.debounce(function () {
      this.isTyping = false;
    }, 1000),
    "searchParams.discipline": _.debounce(function () {
      this.isTyping = false;
    }, 1000),
    isTyping: function (value) {
      if (!value) {
        this.onFiltersChanged();
        // Refresh the exercice page with the provided parameters
        this.getExercicePage();
      }
    },
  },

  computed: {
    headers() {
      var headers = [
        {
          text: "Titre",
          value: "title",
        },
        {
          text: "Destination",
          value: "destinationType",
        },
        {
          text: "Discipline",
          value: "disciplineName",
        },
        {
          text: "Créateur",
          value: "email",
        },
      ];

      // Display exercise type column only if several types
      if (!this.onlyRefs) {
        headers.push({
          text: "Type",
          value: "exerciseType",
        });
      }

      return headers;
    },
  },

  async mounted() {
    this.retrieveExercices();
  },

  methods: {
    // Build the request params based on page parameters
    getRequestParams(userId, searchParams, page, pageSize, sortBy, sortDesc) {
      let params = {};
      if (userId) {
        params["userId"] = userId;
      }
      if (searchParams) {
        params["searchParams"] = searchParams;
      }
      if (page) {
        params["page"] = page;
      }
      if (pageSize) {
        params["size"] = pageSize;
      }
      if (sortBy) {
        params["sortBy"] = sortBy;
      }
      if (sortDesc) {
        params["sortDesc"] = sortDesc;
      }
      return params;
    },
    // Use request params to call REST API and get the paginated list of exercices
    retrieveExercices() {
      const userId = AuthService.userId;
      this.userId = userId;
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      this.page = page;
      this.pageSize = itemsPerPage;
      this.sortBy = sortBy;
      this.sortDesc = sortDesc;

      // Get the enum value of textual sort Exercice property in order to request the REST API
      var sortByEnum = this.convertExerciceTextPropertiesIntoEnum(sortBy[0]);

      // Get the search params if exists
      let searchParams = {};
      if (this.searchParams) {
        searchParams = {
          id: this.searchParams.id,
          title: this.searchParams.title
            ? this.searchParams.title.trim().toLowerCase()
            : "",
          destinationType: this.searchParams.destinationType
            ? this.searchParams.destinationType
            : DestinationType.UNDEFINED,
          user: this.searchParams.user
            ? this.searchParams.user.trim().toLowerCase()
            : "",
          discipline: this.searchParams.discipline
            ? this.searchParams.discipline.trim().toLowerCase()
            : "",
          exerciseType: this.searchParams.exerciseType
            ? this.searchParams.exerciseType
            : ExerciseType.UNDEFINED,
        };
      }

      // Build the parameters
      const params = this.getRequestParams(
        this.userId,
        searchParams,
        this.page,
        this.pageSize,
        sortByEnum,
        this.sortDesc
      );

      // Call the REST API service
      GetExercisesForCurrentUserLightAsync(params, this.onlyRefs)
        .then((response) => {
          const { exerciceDatatableItems, totalExercices } = response;
          this.exercices = exerciceDatatableItems;
          this.totalExercices = totalExercices;
        })
        .catch((e) => {
          // store.dispatch("setSnackbar", {
          //   title: "Erreur",
          //   text: "La récupération des exercices n'a pas fonctionnée.",
          //   color: "error",
          // });
        });
    },

    // Refresh the exercice page with the provided parameters
    getExercicePage() {
      this.retrieveExercices();
    },

    // Convert textual value of Exercice property into ExerciceSortType enum
    convertExerciceTextPropertiesIntoEnum(textProp) {
      var result = ExerciceSortType.UNDEFINED;

      switch (textProp) {
        case "id":
          result = ExerciceSortType.ID;
          break;
        case "title":
          result = ExerciceSortType.TITLE;
          break;
        case "destinationType":
          result = ExerciceSortType.DESTINATION;
          break;
        case "email":
          result = ExerciceSortType.EMAIL;
          break;
        case "exerciseType":
          result = ExerciceSortType.TYPENAME;
          break;
        case "disciplineName":
          result = ExerciceSortType.DISCIPLINE;
          break;
        default:
          break;
      }

      return result;
    },

    // on filters changed
    onFiltersChanged() {
      // reset to page 1
      this.options.page = 1;
      this.page = 1;
    },

    // On click to clear the title search input
    onClearTitleClicked() {
      this.searchParams.title = null;
      this.onFiltersChanged();
    },
    // On click to clear the destination search input
    onClearDestinationClicked() {
      this.searchParams.destinationType = null;
      this.onFiltersChanged();
    },
    // On click to clear the discipline search input
    onClearDisciplineClicked() {
      this.searchParams.discipline = null;
      this.onFiltersChanged();
    },
    // On click to clear the user search input
    onClearUserClicked() {
      this.searchParams.user = null;
      this.onFiltersChanged();
    },
    // On click to clear the type search input
    onClearTypeClicked() {
      this.searchParams.exerciseType = null;
      this.onFiltersChanged();
    },

    selectExercise(exercise) {
      this.$emit("back");
      bus.$emit("reference", exercise);
    },

    back() {
      this.$emit("back");
    },
  },
};
</script>